import { observer } from 'mobx-react-lite';
import { Button, Grid,} from 'semantic-ui-react';
import { store, useStore } from '../../../app/stores/store';
import OrderRequestForm from '../Receiving/Delivery/OrderRequestForm';
import OrderRegisterForm from '../Receiving/Delivery/OrderRegisterForm';
import DashboardDeliveryForm from '../Receiving/Delivery/DashboardDeliveryForm';
import CreateOrderContainer from '../Receiving/CreateOrder/CreateOrderContainer';
import OrderRegisterTable from '../Receiving/Delivery/OrderRegisterTable';
import DeliveryTable from '../Receiving/Delivery/DeliveryTable';
import DeliveryAssignPicker from '../Receiving/Delivery/DeliveryAssignPicker';
import { useEffect, useState } from 'react';
import ChartData from '../Charts/ChartData';
import DynamicTableComponent from '../../DynamicTable/DynamicTableComponent';
import { v4 as uuid } from 'uuid';
import { Activity } from '../../../app/models/activity';
import _ from 'lodash';
import QuickScanModal from '../../QuickScan/QuickScanModal';
import agent from '../../../app/api/agent';
import MovetoVaultModal from './MovetoVaultModal';


function DashboardGridDelivery() {
  const { reportStore, dashboardStore, activityStore,userStore,commonStore,vaultStore:{getHFCVaultList} } = useStore();
  const[barcode, setBarcode]= useState<string[]>([])
  const { loadDeliveries, deliveryRegistry } = activityStore;
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [pageNumber, setPageNumber] = useState(1);
  const[isSubmit, setIssubmit]= useState<boolean>(false);
  const [vaultData, setVaultData] = useState<any[]>([]);
  const[isModal, setIsModal]= useState<boolean>(false);
  const { activitiesByDate, HFCVaultloadActivitiesPagination } =
  activityStore;

  const openTagModal =()=>{
    setIsModal(true);
  }
  useEffect(() => {
    const fetchData = async () => {
        await getHFCVaultList();
    };
    fetchData();
    // eslint-disable-next-line
}, [isModal]);

  useEffect(() => {
    if (deliveryRegistry.size <= 1) loadDeliveries();
  }, [deliveryRegistry.size, loadDeliveries]);
  //for delivery request
  useEffect(() => {
    if(commonStore.hfcCustomerChanges){
      const pageSize = 5;
      activityStore.HFCVaultloadActivitiesPagination(1, userStore?.user!.id, pageSize, []) 
    }
    // eslint-disable-next-line
  }, []);

  const userID = userStore.user?.id !== undefined ? userStore.user?.id : '';
  const tableData: Activity[] = [];

  
  async function submitHandler() {
    var input = document.getElementById(
      'myInputQuickscan',
    ) as HTMLTextAreaElement;
    let value = input.value;
    
    let barcodeDetails = value.split('\n');
    if (barcodeDetails[barcodeDetails.length - 1] === '') {
      barcodeDetails.pop();
  }
  setBarcode(barcodeDetails)
   const res =  await agent.HFC.HFCscanAsset(1,5, barcodeDetails)
    setVaultData(res.data)
  // const scanRes= await agent.HFC.HFCscanAssetBarcodes(barcodeDetails)
  //   const containerBarcode = scanRes.data
  //   const containerList = containerBarcode.map((item:any)=>{
  //     return{
  //       key:item,
  //       value:item,
  //       text:item
  //     }
  //   })
  //   setScanData(containerList)
    const countres=await agent.HFC.HFCscanCount(barcodeDetails)
    dashboardStore.dashboard.ScanCount = countres.data
    reportStore.HFCallocateItemToUserArray=[]
    setOpenModal(false);
    setIssubmit(true);
    reportStore.isCheckAll.checked= false;
    reportStore.HFCCheck = false
  }

  activitiesByDate?.forEach((a: any) => {
    // isMaster
    delete a?.isMaster;
    // eslint-disable-next-line
    delete a?.sections_Multiple_From;
    delete a?.sections_From;
    delete a?.synopsis;

    tableData?.push({
      ...a,
      //  movementdate:userReadableDateFormat(a.movementdate),
      //  movement_Time:userReadableDateFormat(a.movement_Time),
      //  maintenance:userReadableDateFormat(a.maintenance),
      //  receivingdate:userReadableDateFormat(a.receivingdate),
      //  status_Time: userReadableDateFormat(a.status_Time),
      //  itemCreatedAt:userReadableDateFormat(a.itemCreatedAt)
    });
  });
  const createOrderFilter = tableData?.filter((x) => x?.isReceiving === false);
  const MainFilter =
    dashboardStore.dashboard.L2CardValueInventory === 'Receiving' &&
    dashboardStore.dashboard.valueForL3Inventory === 'Create Order Receiving'
      ? createOrderFilter
      : tableData;

  const removeCol =
    'isReceiving,isDelivery,isReceivingOrder,files,assignedUsers,comments,itemHistory,orders,itemDeliveryRequest,inwards,typeid,thumbnail,preview,proxy,global_positioning_system,isHost,elementtypeid,receivings,host,isDeleted,isActive,cast,thumbnail_large,thumbnail_small,groove_type,speed_and_speed_adjustment,number_of_channels_and_sound_channel_map,file_format_name_and_version,analog_media,format_in_terms_of_broadcast_standards,bits_per_sample_and_sampling_description,songs,physcial_format,host,hostUsername,originIndia,inactive,isgoing,ishost,clearedon';
  const assettable = JSON.parse(JSON.stringify(MainFilter));
  assettable.map((i: any) => removeCol.split(',').map((j) => delete i[j]));

  const paginateFunction = async(e: number) => {
    const resultArray = Object.entries(dashboardStore.dashboard.searchfilterparams).map(([header, searchValue]) => ({
      header,
      searchValue
    }));
    if (
      !_.isEmpty(dashboardStore.dashboard.searchfilterparams) &&
      Object.values(dashboardStore.dashboard.searchfilterparams).every(
        (o) => o !== '',
      ) &&
      dashboardStore.dashboard.orderData === '' &&
      dashboardStore.dashboard.orderName === ''
    ) {
      commonStore.hfcCustomerChanges ?
      activityStore.HFCsearchListItems(resultArray,
        e,
        5) :
      activityStore.searchListItems(
        dashboardStore.dashboard.searchfilterparams,
        e,
        5,
      );
    } else if (
      dashboardStore.dashboard.orderData !== '' &&
      dashboardStore.dashboard.orderName !== ''
    ) {
      activityStore.sortListItems(
        dashboardStore.dashboard.orderName,
        dashboardStore.dashboard.orderData,
        e,
        5,
      ); 
    } else {
      if (isSubmit) {
        const res =await agent.HFC.HFCscanAsset(e, 5, barcode);
        setVaultData(res.data)
        await agent.HFC.HFCscanCount(barcode);
      } else {
        await HFCVaultloadActivitiesPagination(e, userID, 5, []);
      }
    }
    dashboardStore.setTagPageNumFunc(e);
    setPageNumber(e);
  };

  return (
    <div>
      { isModal && (<MovetoVaultModal isModal={isModal} setIsModal={setIsModal}  scanData={reportStore.scanData} setIssubmit={setIssubmit} barcode={barcode}/>) }
      {
         store.commonStore.hfcCustomerChanges? 
         <>
         <div style={{textAlign: "right", marginBottom: "15px"}}><Button primary onClick={() => setOpenModal(true)}>scan</Button></div>
         {
          isSubmit ?   
          <>
            <DynamicTableComponent
            key={uuid()}
            data={vaultData}
            name={'HFCScan'}
            actiontype={''}
            pageFunc={paginateFunction}
            pageNumData={pageNumber}
            searchFuncData={()=>{}}
            openTagModal={openTagModal}
            />
        </> 
        : 
        <>
        <DynamicTableComponent  key={uuid()} data={assettable} name={'HFCMoveToVault'}
          actiontype={''} loading={!activityStore.HFCVaultloadActivitiesPagination || activityStore.loadCountAssetTable} pageFunc={paginateFunction} pageNumData={pageNumber} searchFuncData={()=>{}}/></>
         }
         {
           openModal && (
             <QuickScanModal
               open={openModal}
               setOpen={setOpenModal}
               submitHandler={submitHandler}
             />
           )
         }
         </>
          :
           (
         <>
               {dashboardStore.dashboard.L1CardValue === 'Inventory' &&
        dashboardStore.dashboard.L2CardValueInventory === 'Delivery' &&
        dashboardStore.dashboard.valueForL3Inventory === '' && (
          <Grid stackable>
            <Grid.Row>
              <ChartData />
            </Grid.Row>
            <Grid.Row>
              <DeliveryTable size={'DeliveryTableBig'} />
            </Grid.Row>
          </Grid>
        )}
      {dashboardStore.dashboard.L1CardValue === 'Inventory' &&
        dashboardStore.dashboard.L2CardValueInventory === 'Delivery' &&
        dashboardStore.dashboard.valueForL3Inventory === 'Order Request' && (
          <OrderRequestForm />
        )}
      {dashboardStore.dashboard.L2CardValueInventory === 'Delivery' &&
        dashboardStore.dashboard.valueForL3Inventory === 'Delivery' && (
          <Grid stretched columns={2}>
            <Grid.Column>
              <DeliveryTable size={'DeliveryTableSmall'} />
            </Grid.Column>
            <Grid.Column>
              <DashboardDeliveryForm />
            </Grid.Column>
          </Grid>
        )}
      {dashboardStore.dashboard.L2CardValueInventory === 'Delivery' &&
        dashboardStore.dashboard.valueForL3Inventory === 'Order Register' && (
          <Grid stackable columns={2}>
            <Grid.Column>
              <OrderRegisterTable />
            </Grid.Column>
            <Grid.Column>
              <OrderRegisterForm />
            </Grid.Column>
          </Grid>
        )}

      {dashboardStore.dashboard.L2CardValueInventory === 'Delivery' &&
        dashboardStore.dashboard.valueForL3Inventory === 'Approve' && (
          <DeliveryTable size={'DeliveryTableBig'} />
        )}
      {dashboardStore.dashboard.L2CardValueInventory === 'Delivery' &&
        dashboardStore.dashboard.valueForL3Inventory === 'Create Order' && (
          <Grid stackable columns={2}>
            <Grid.Column>
              <DeliveryTable size={'DeliveryTableSmall'} />
            </Grid.Column>
            <Grid.Column>
              <CreateOrderContainer name={'Outward Process Instructions'} />
            </Grid.Column>
          </Grid>
        )}

      {dashboardStore.dashboard.L2CardValueInventory === 'Delivery' &&
        dashboardStore.dashboard.valueForL3Inventory ===
          'Assign Picker Delivery' && (
          <Grid stackable columns={2}>
            <Grid.Column>
              <DeliveryTable size={'DeliveryTableSmall'} />
            </Grid.Column>
            <Grid.Column>
              <DeliveryAssignPicker />
            </Grid.Column>
          </Grid>
        )}
         </>
        )
      }
    </div>
  );
}

export default observer(DashboardGridDelivery);
